(function () {
  const initContentWithNavigation = (section) => {
    if (
      !section ||
      !section?.classList.contains("content-with-navigation-section")
    ) {
      return;
    }

    const items = document.querySelectorAll(".content-with-navigation__item");
    const titles = document.querySelectorAll(
      ".content-with-navigation__aside--title"
    );

    // --- ADDED: Lock mechanism ---
    let isManualScrolling = false;
    let scrollTimeout;

    const setActiveTitle = (index) => {
      titles.forEach((title, i) => {
        const isActiveIndex = i === index;
        title.classList.toggle("active", isActiveIndex);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (isManualScrolling) {
              return;
            }
            const index = Array.from(items).indexOf(entry.target);
            setActiveTitle(index);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: `0px 0px -80% 0px`,
      }
    );

    items.forEach((item) => observer.observe(item));

    titles.forEach((title, index) => {
      title.addEventListener("click", function (e) {
        // Set the lock
        isManualScrolling = true;

        // Detecting if the page is being scrolled Up
        var currentActiveIndex = -1;
        [...titles].map((title, i) => {
          if (title.classList.contains("active")) {
            currentActiveIndex = i;
          }
        });

        const climbedUp = index < currentActiveIndex;
        setActiveTitle(index, (setupAnchor = true));
        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
          isManualScrolling = false;
        }, 600);

        e.preventDefault();
        if (climbedUp) {
          const header = document.querySelector(".shopify-section-header");
          const headerHeight = header ? header.offsetHeight : 0;

          const cwnMenuHeight = setupMenuHeight();

          const top =
            items[index].getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight -
            (window.innerWidth < 1100 ? cwnMenuHeight : 0);

          window.scrollTo({
            top,
            behavior: "smooth",
          });
        } else {
          if (window.innerWidth < 1100) {
            const cwnMenuHeight = setupMenuHeight();

            const top =
              items[index].getBoundingClientRect().top +
              window.pageYOffset -
              (window.innerWidth < 1100 ? cwnMenuHeight : 0);

            window.scrollTo({
              top,
              behavior: "smooth",
            });
          } else {
            items[index].scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    });

    const setupMenuHeight = () => {
      const cwnMenuHeight = section.querySelector(
        ".content-with-navigation__aside"
      ).clientHeight;
      section
        .querySelector(".content-with-navigation")
        .style.setProperty("--cwn-menu-height", cwnMenuHeight);
      return cwnMenuHeight;
    };

    setupMenuHeight();

    window.addEventListener("resize", setupMenuHeight);
  };

  initContentWithNavigation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", (e) =>
    initContentWithNavigation(e.target)
  );

  document.addEventListener("shopify:section:select", function (event) {
    initContentWithNavigation(event.target);
  });

  document.addEventListener("shopify:block:change", function (event) {
    initContentWithNavigation(event.target);
  });

  document.addEventListener("shopify:section:change", function (event) {
    initContentWithNavigation(event.target);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initContentWithNavigation(event.target);
  });
})();
